import { FETCH_MENU, FETCH_ITEM_DETAILS, UPDATE_SEARCH_RESULTS, PLP_NAVIGATION_PARAM, CLEAR_PLP_NAVIGATION_PARAM, CLEAR_SEARCH_RESULTS, GET_PRODUCT_SUGGESTIONS, RECOMMENDED_PRODUCT, SET_ITEM_FAVOURITE, SET_ITEM_UN_FAVOURITE, RESET_ITEM_FAVOURITE_SUCCESS, RESET_ITEM_UNFAVOURITE_SUCCESS, SET_SELECTED_VIEW_MODE, RESET_MENU, RESET_FULFILLMENT, } from '../../constants';
export function fetchMenuAction(menuPayload, exclusionPayload, sucessCallBack = null) {
    return {
        type: FETCH_MENU,
        menuPayload,
        exclusionPayload,
        sucessCallBack,
    };
}
export function fetchItemDetailsAction(payload, sucessCallBack = null, errorCallBack = null) {
    return {
        type: FETCH_ITEM_DETAILS,
        payload,
        sucessCallBack,
        errorCallBack,
    };
}
export function updateSearchResultsAction(searchResultsPayload, query, callback = null) {
    return {
        type: UPDATE_SEARCH_RESULTS,
        searchResultsPayload,
        query,
        callback,
    };
}
export function clearSearchResultsAction() {
    return {
        type: CLEAR_SEARCH_RESULTS,
    };
}
export function getProductSuggestions(payload) {
    return {
        type: GET_PRODUCT_SUGGESTIONS,
        payload,
    };
}
export function recommendedProductAction(payload) {
    return {
        type: RECOMMENDED_PRODUCT,
        payload,
    };
}
export function addItemToFavouriteAction(payload, postBody) {
    return {
        type: SET_ITEM_FAVOURITE,
        payload,
        postBody,
    };
}
export function resetItemFavSuccessAction() {
    return { type: RESET_ITEM_FAVOURITE_SUCCESS };
}
export function addItemToUnFavouriteAction({ tenantId, customerId, itemId }) {
    return {
        type: SET_ITEM_UN_FAVOURITE,
        payload: { tenantId, customerId, itemId },
    };
}
export function resetItemUnFavSuccessAction() {
    return { type: RESET_ITEM_UNFAVOURITE_SUCCESS };
}
export function setViewMode(mode) {
    return {
        type: SET_SELECTED_VIEW_MODE,
        payload: mode,
    };
}
export function plpNavigationParamData(path) {
    return {
        type: PLP_NAVIGATION_PARAM,
        path,
    };
}
export function clearPLPNavigationParamData() {
    return {
        type: CLEAR_PLP_NAVIGATION_PARAM,
    };
}
export function resetMenu() {
    return {
        type: RESET_MENU,
    };
}
export function resetMenuFulfillmentData() {
    return {
        type: RESET_FULFILLMENT,
    };
}
